var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "panel",
      attrs: {
        app: "",
        temporary: "",
        right: "",
        width: "600",
        flat: "",
        "overlay-color": "grey-500",
      },
      on: {
        input: function ($event) {
          _vm.mini = !_vm.mini
        },
      },
      model: {
        value: _vm.activePanel,
        callback: function ($$v) {
          _vm.activePanel = $$v
        },
        expression: "activePanel",
      },
    },
    [
      _c(
        "div",
        {
          staticStyle: {
            position: "fixed",
            "z-index": "1000 !important",
            "min-width": "100%",
          },
        },
        [
          _c(
            "v-toolbar",
            { attrs: { flat: "", height: "46", color: "grey-background" } },
            [
              _c(
                "v-toolbar-title",
                {
                  staticClass:
                    "px-5 subtitle-2 grey-500--text font-weight-bold",
                },
                [_vm._v(_vm._s(_vm.title))]
              ),
              _c("v-spacer"),
              _c(
                "v-toolbar-items",
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mr-3",
                      attrs: { align: "center", justify: "center" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            small: "",
                            "retain-focus-on-click": "",
                          },
                          on: { click: _vm.closePanel },
                        },
                        [
                          _c(
                            "v-icon",
                            { attrs: { color: "grey-500", size: "20" } },
                            [_vm._v("mdi-close")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c("v-divider"),
        ],
        1
      ),
      _c("div", [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }